/**
 * Admin API URLs — same paths as legacy admin (`src_admin/lib/api-endpoints.ts`).
 * Base URL matches `src_backup/components/ApiService/endpoints.js`: `REACT_APP_API_BASE_URL`.
 */
export const BASE_URL = process.env.REACT_APP_API_BASE_URL || '';

export const USERS_API = `${BASE_URL}/user/users`;
export const PAYMENTS_API = `${BASE_URL}/user/payments`;
export const USER_BALANCE_API = `${BASE_URL}/user/balance`;
export const ADD_BALANCE_API = `${BASE_URL}/user/add-balance`;
export const PRICING_API = `${BASE_URL}/user/pricing`;
export const PRICING_CREATE_API = `${BASE_URL}/user/pricing/create`;
export const PRICING_UPDATE_API = (id) => `${BASE_URL}/user/pricing/${id}`;
export const EMBEDDED_USERS_API = `${BASE_URL}/user/embedded-users`;
export const INSERT_USER_API = `${BASE_URL}/user/insert-user`;
export const MESSAGE_STATS_ALL_API = `${BASE_URL}/user/message-stats-all`;
export const WHATSAPP_CATALOGS_API = `${BASE_URL}/user/whatsapp-catalogs`;
export const WHATSAPP_CATALOG_PRODUCTS_API = `${BASE_URL}/user/whatsapp-catalog-products`;
export const WHATSAPP_CATALOG_PRODUCT_CREATE_API = `${BASE_URL}/user/whatsapp-catalog-products/create`;
export const WHATSAPP_CATALOG_PRODUCT_UPDATE_API = `${BASE_URL}/user/whatsapp-catalog-products/update`;
export const WHATSAPP_CATALOG_PRODUCT_UPDATE_INVENTORY_API = `${BASE_URL}/user/whatsapp-catalog-products/update-inventory`;
export const WHATSAPP_CATALOG_PRODUCT_DELETE_API = `${BASE_URL}/user/whatsapp-catalog-products/delete`;
export const WHATSAPP_CATALOG_PRODUCT_UPLOAD_IMAGE_API = `${BASE_URL}/user/whatsapp-catalog-products/upload-image`;
export const TEMPLATES_API = `${BASE_URL}/templates/get-templates`;
export const NUMBER_REPORT_API = `${BASE_URL}/wa/number-report`;
export const INCOMING_MESSAGES_API = `${BASE_URL}/wa/incoming-messages`;
export const LOGIN_API = `${BASE_URL}/auth/login`;
